import FieldRepeater from './wpum-field-repeater'

export default [ FieldRepeater ]



// WEBPACK FOOTER //
// ./src/registration-forms-editor/components/field-types/index.js